import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const PostalCodeColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelConfiguration, externalFulfillmentConfiguration } =
    useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const shipTo = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo;

  const { postalCode } = shipTo ?? {};

  return postalCode;
};

PostalCodeColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const PostalCode = {
  getMessageDescriptor: () => messages.postalCode,
  id: 'postalCode',

  render: (data) => {
    return data && <PostalCodeColumn fulfillmentId={data.id} />;
  },
};
